module.exports = __webpack_public_path__ + "fonts/Nunito-400-latin5.b8644b6.woff2";